import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ResetPasswordService } from './resetpassword.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import {encryptdecrypt} from '../encryptdecrypt';
@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.css']
})
export class ResetpasswordComponent implements OnInit {
  resetForm: FormGroup;
  postresult: boolean;
  email: string;
  userid: string;
  submitted = false;
  loading = false;
  error: string;
  encryptPassword='';
  passwordComplexity=0;
  timeSpan:string;
  public barLabel: string = "Password strength:";
  public account = {  
        password: null  
      }; 
  constructor(private formBuilder: FormBuilder,   
    private resetservice: ResetPasswordService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
     private router: Router
  ) {
   
  }
  ngOnInit() {
    this.resetForm = this.formBuilder.group({
      newpassword: ['', Validators.required],
      confirmpassword: ['', Validators.required]
    });
    this.email = this.route.snapshot.queryParamMap.get('email'); 
    this.timeSpan= this.route.snapshot.queryParamMap.get('tspan');   
   
  }
  get f() { return this.resetForm.controls; }

  getfrmValue($event) {    
    this.passwordComplexity = $event;
      }
  onSubmit(http: HttpClient) {
    this.submitted = true;
    this.loading = true;
console.log(this.passwordComplexity);
    if(+this.passwordComplexity <=69){
      this.toastr.error("Please use complex password");
      return;
    }

    if (this.f.newpassword.value != this.f.confirmpassword.value) {
      this.toastr.error("Confirm password and new password should be same");
      return;
    }
    let a= new encryptdecrypt();
   this.encryptPassword = a.encryptUsingAES256(this.f.newpassword.value.toString())
   console.log(this.encryptPassword);
    this.resetservice.resetpassword(this.encryptPassword.toString(), this.email,this.timeSpan).subscribe(res => {
      //console.log(res);
      if (res.status == 200) { this.postresult = true; this.ngOnInit() };
      this.toastr.success('Password Reset has been done successfully');
      this.router.navigate(['/login']);
    },
      error => {
        if((error.error=="Reset password url is expired.")||(error.error=="Reset password url is not valid.")){
          this.toastr.error(error.error);
          this.postresult = false
        }else{
        this.toastr.error("Password not changed.Some unexpected error.");
        this.postresult = false
        this.error = error.error;
        }
      })
    this.loading = false;
  } 
}
